import { render, staticRenderFns } from "./adult.vue?vue&type=template&id=7531bf24&scoped=true"
import script from "./adult.vue?vue&type=script&lang=js"
export * from "./adult.vue?vue&type=script&lang=js"
import style0 from "./adult.vue?vue&type=style&index=0&id=7531bf24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7531bf24",
  null
  
)

export default component.exports